import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-tv-formats',
  templateUrl: './broadcastings-tv-formats.component.html',
  styleUrls: ['./broadcastings-tv-formats.component.scss']
})
export class BroadcastingsTvFormatsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
